const ColumnDateFilterMenuTestIdsScope = {
  COLUMN_DATE_FILTER: 'column-date-filter',
};

export const ColumnDateFilterMenuTestIds = {
  TRIGGER: `${ColumnDateFilterMenuTestIdsScope.COLUMN_DATE_FILTER}.trigger`,
  START_FIELD: `${ColumnDateFilterMenuTestIdsScope.COLUMN_DATE_FILTER}.start-field`,
  END_FIELD: `${ColumnDateFilterMenuTestIdsScope.COLUMN_DATE_FILTER}.end-field`,
  CLEAR_BUTTON: `${ColumnDateFilterMenuTestIdsScope.COLUMN_DATE_FILTER}.clear-button`,
  CONFIRM_BUTTON: `${ColumnDateFilterMenuTestIdsScope.COLUMN_DATE_FILTER}.confirm-button`,
};
